<app-popup-page
  (closePopup)="closeModal()"
  [config]="config"
  (pageBack)="back()"
  (pageNext)="next()"
>
  <ng-container [ngSwitch]="currentStep">
    <app-welcome-first-step
      *ngSwitchCase="1"
      (config)="updateConfig($event)"
    ></app-welcome-first-step>

    <app-welcome-second-step
      *ngSwitchCase="2"
      (config)="updateConfig($event)"
    ></app-welcome-second-step>

    <app-welcome-third-step
      *ngSwitchCase="3"
      (config)="updateConfig($event)"
    ></app-welcome-third-step>
  </ng-container>
</app-popup-page>
